import { Component, OnInit } from "@angular/core";
import { first } from "rxjs/operators";
import { DashboardDirectionJuridiqueService } from "../../core/service/dashboard-direction-juridique.service";
import * as Highcharts from "highcharts";
import { ChartViewDTO } from "../../core/model/chart_view/chart-view-dto";
import { QuantiteAndPourcentageDTO } from "../../core/model/quantite-and-pourcentage-dto";
import { QuantiteDossierPortefeuilleJuridiqueParProduitDTO } from "../../core/model/quantite-dossier-portefeuille-juridique-par-produit-dto";
import { QuantiteDossierPortefeuilleJuridiqueParProfileDTO } from "../../core/model/quantite-dossier-portefeuille-juridique-par-profile-dto";

@Component({
  selector: "app-jur-production",
  templateUrl: "./jur-production.component.html",
  styleUrls: ["./jur-production.component.scss"],
})
export class JurProductionComponent implements OnInit {
  quantiteAndPourcentageDTOs: QuantiteAndPourcentageDTO[];

  highcharts = Highcharts;
  chartOptionsDossiersEncours: any;
  chartOptionsDossiersEncoursTraite: any;

  chartEncours: ChartViewDTO;
  chartEncoursTraite: ChartViewDTO;

  quantiteDossierPortefeuilleJuridiqueDTOs: QuantiteDossierPortefeuilleJuridiqueParProduitDTO[];

  quantiteDossierPortefeuilleJuridiqueProfileDTOs: QuantiteDossierPortefeuilleJuridiqueParProfileDTO[];

  constructor(
    private _dashboardDirectionJuridiqueService: DashboardDirectionJuridiqueService
  ) {}

  ngOnInit() {
    this.quantiteDossierPortefeuille();
    this.quantiteDossierPortefeuille12DerniersMois();
    this.quantiteDossierTraiteEtEncourssur12DerniersMois();
    this.quantiteDossierPortefeuilleParProduit();
    this.quantiteDossierPortefeuilleParProfile();
  }

  quantiteDossierPortefeuille() {
    this._dashboardDirectionJuridiqueService
      .quantiteDossierPortefeuille()
      .subscribe(
        (data) => {
          this.quantiteAndPourcentageDTOs = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  quantiteDossierPortefeuilleParProduit() {
    this._dashboardDirectionJuridiqueService
      .quantiteDossierPortefeuilleParProduit()
      .subscribe(
        (data) => {
          this.quantiteDossierPortefeuilleJuridiqueDTOs = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  quantiteDossierPortefeuilleParProfile() {
    this._dashboardDirectionJuridiqueService
      .quantiteDossierPortefeuilleParProfile()
      .subscribe(
        (data) => {
          this.quantiteDossierPortefeuilleJuridiqueProfileDTOs = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  quantiteDossierPortefeuille12DerniersMois() {
    this._dashboardDirectionJuridiqueService
      .quantiteDossierPortefeuille12DerniersMois()
      .pipe(first())
      .subscribe(
        (response) => {
          this.chartEncours = response;

          this.chartOptionsDossiersEncours = {
            chart: {
              type: "spline",
            },
            title: {
              text: "Dossiers en cours sur les 6 derniers mois",
            },
            subtitle: {
              text: null,
            },
            xAxis: {
              categories: this.chartEncours.categories,
            },
            yAxis: {
              title: {
                text: "Quantité",
              },
            },
            tooltip: {
              valueSuffix: null,
            },
            series: this.chartEncours.series,
          };
        },
        (error) => {
          console.log(error);
        }
      );
  }

  quantiteDossierTraiteEtEncourssur12DerniersMois() {
    this._dashboardDirectionJuridiqueService
      .quantiteDossierTraiteEtEncourssur12DerniersMois()
      .pipe(first())
      .subscribe(
        (response) => {
          this.chartEncoursTraite = response;

          this.chartOptionsDossiersEncoursTraite = {
            chart: {
              type: "column",
            },
            title: {
              text: "Dossiers en cours vs dossiers traités",
            },
            subtitle: {
              text: null,
            },
            xAxis: {
              categories: this.chartEncoursTraite.categories,
              crosshair: true,
            },
            yAxis: {
              min: 0,
              title: {
                text: "Quantité",
              },
            },
            tooltip: {
              headerFormat:
                '<span style = "font-size:10px">{point.key}</span><table>',
              pointFormat:
                '<tr><td style = "color:{series.color};padding:0">{series.name}: </td>' +
                '<td style = "padding:0"><b>{point.y:.1f} </b></td></tr>',
              footerFormat: "</table>",
              shared: true,
              useHTML: true,
            },
            plotOptions: {
              column: {
                pointPadding: 0.2,
                borderWidth: 0,
              },
            },
            series: this.chartEncoursTraite.series,
          };
        },
        (error) => {
          console.log(error);
        }
      );
  }
}
